import { useQuery } from "@tanstack/react-query";
import { PrimarySecondaryPage } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { Navigate } from "react-router";
import { getAIRsDataQueryOptions } from "shared-ui";
import { useCustomerAppConfig } from "undercarriage";
import { OnboardingStepper } from "onboarding";

import { ReviewScreenEmailVerification, ReviewScreenEmailVerificationBlockSecondaryContent } from "../../components";
import { useInReviewDetails } from "../../queries/review-screen/review-screen-queries";

import { MESSAGES } from "./message-definitions";
import { Review } from "./primary-content/review";
/**
 * ReviewScreen component
 */
export const ApplicationReviewPage = () => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();

  const { data: reviewData, isFetchedAfterMount: isReviewDataFetched } = useInReviewDetails(customerDomain);
  const { data: airsData, isFetchedAfterMount: airsDataFetched } = useQuery({
    ...getAIRsDataQueryOptions(customerDomain),
  });

  if (reviewData && !reviewData.isProductRequestInProgress) {
    return <Navigate to="/" />;
  }

  const isReady = !!(reviewData && isReviewDataFetched && airsData && airsDataFetched);

  const titleSlot = !isReady || reviewData.isSubsequentFunding ? null : <OnboardingStepper currentStep={5} />;
  const title =
    airsData?.hasActiveAirs || airsData?.hasActiveManualAirs
      ? MESSAGES.reviewScreenAirOnHoldHeading
      : MESSAGES.reviewScreenHeading;

  // for subsequent funding we are not requiring them to verify email as it would be a terrible UX
  if (isReady && !reviewData.emailVerified && !reviewData.isSubsequentFunding) {
    return (
      <PrimarySecondaryPage
        titleSlot={titleSlot}
        showStepperBackground={!!titleSlot}
        title={intl.formatMessage(MESSAGES.reviewScreenEmailVerificationRequiredTitle)}
        titleWrap="wrap"
        primaryContent={<ReviewScreenEmailVerification emailAddress={reviewData.email} />}
        secondaryContent={<ReviewScreenEmailVerificationBlockSecondaryContent />}
      />
    );
  }

  return (
    isReady && (
      <PrimarySecondaryPage
        titleSlot={titleSlot}
        showStepperBackground={!!titleSlot}
        title={intl.formatMessage(title)}
        titleWrap="wrap"
        primaryContent={<Review airsData={airsData} reviewData={reviewData} />}
      />
    )
  );
};
